import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { formatNumber } from "@l2r-front/l2r-utils"

import { RoadworksStats } from "../../components/RoadworksStats"
import { useRoadworksStateContext } from "../../contexts/RoadworksContext"
import { useRoadworksStats } from "../../hooks/queries/useRoadworksStats"

import * as Styled from "./RoadworkStat.styled"

export function RoadworkCost(props) {

    const {
        title,
    } = props

    const { apiFilters, currency } = useRoadworksStateContext()
    const { road } = useParams()
    const { data: stats } = useRoadworksStats({ linear_location_road: road, ...apiFilters })

    const filteredCost = useMemo(() => {
        if (!stats?.cost) {
            return null
        }
        const statusFilter = apiFilters?.status?.length
            ? apiFilters.status
            : apiFilters?.status__in?.length
                ? apiFilters.status__in
                : []


        if (statusFilter.length === 0) {
            return Object.values(stats.cost).reduce((sum, value) => sum + Number(value), 0)
        }
        return statusFilter.reduce((sum, key) => sum + (Number(stats.cost[key]) || 0), 0)
    }, [apiFilters.status, apiFilters.status__in, stats])

    const displayedCost = useMemo(() => filteredCost, [filteredCost])

    return <RoadworksStats title={title}>
        <Styled.Stat id="roadworks-total-cost">{formatNumber(displayedCost)} {currency?.symbol}</Styled.Stat>
    </RoadworksStats>
}

RoadworkCost.propTypes = {
    title: PropTypes.string,
}
